import { TFunction } from "i18next";
import { SecondaryColor, SemanticColor } from "node-library/dist/colors";
import { OrderStatus, TurnaroundTime } from "node-library/dist/constants";
import { OrderTableSortColumn } from "node-library/dist/paginations";
import { FrontendOrder } from "node-library/dist/portal";

export function getStatusString(
	status: OrderStatus,
	translation: TFunction<"translation", undefined>
): string {
	switch (status) {
		case OrderStatus.IN_PROGRESS:
			return translation("InProgress");

		case OrderStatus.COMPLETE:
			return translation("Complete");
	}
}

export function getStatusDescriptionText(
	status: OrderStatus,
	translation: TFunction<"translation", undefined>
): string {
	switch (status) {
		case OrderStatus.IN_PROGRESS:
			return translation("InProgressOrderDescription");

		case OrderStatus.COMPLETE:
			return translation("CompleteOrderDescription");
	}
}

export function getStatusColors(status: OrderStatus): {
	backgroundColor: string;
	borderColor: string;
	textColor: string;
} {
	switch (status) {
		case OrderStatus.IN_PROGRESS:
			return {
				backgroundColor: SecondaryColor.SECONDARY_100,
				borderColor: SecondaryColor.SECONDARY_500,
				textColor: SecondaryColor.SECONDARY_600,
			};
		case OrderStatus.COMPLETE:
			return {
				backgroundColor: SemanticColor.SUCCESS_100,
				borderColor: SemanticColor.SUCCESS,
				textColor: SemanticColor.SUCCESS_300,
			};
	}
}

export function getOrderSortString(
	sortColumn: OrderTableSortColumn,
	translation: TFunction<"translation", undefined>
): string {
	switch (sortColumn) {
		case OrderTableSortColumn.BARCODE_ID:
			return translation("OrderNumber");
		case OrderTableSortColumn.INSERTED:
			return translation("CreatedTime");
	}
}

export function getOrderAvailableTAT(
	order: FrontendOrder
): Array<TurnaroundTime> {
	const result: Set<TurnaroundTime> = new Set();
	for (const instance of order.sampleInstances) {
		result.add(instance.sampleTestInfo?.turnaroundTime as TurnaroundTime);
	}
	return Array.from(result);
}
